// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Xo-z","breadcrumbForward":"Yo-z","breadcrumbBack":"Zo-z","selected":"_o-z"};